<div class="floating-container">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{errortitle}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <p>{{errormessage}}</p>
          </mat-card-content>
          <mat-card-actions>
            <button mat-raised-button color="accent" class="fill-parent-width" (click)="goHome()">{{errorbutton}}</button>
          </mat-card-actions>
    </mat-card>
</div>